<template>
    <div class="aba-produto-agregado">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="vertical-flow">
            <div class="columns">
                <div class="column">
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-campo-busca-agregadosimilar"
                    />
                </div>

                <div
                    class="column"
                    :class="[permissao.create && !produtoAgregadoIntegracao ? 'is-3' : 'is-4']"
                >
                    <vss-select
                        ref="situacaoSelect"
                        :searchable="false"
                        :options="situacaoSelect"
                        v-model="situacaoSelected"
                        mlLabels
                        title="situacao"
                        clearable
                        @input="onSituacaoChanged"
                        :height="40"
                    />
                </div>

                <div class="column is-3" v-if="!produtoAgregadoIntegracao && permissao.create">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalAgregados = !showModalAgregados"
                    >
                        {{ $t('vincular-produto-agregado') }}
                    </button>
                </div>
            </div>

            <div class="registry-wrapper">
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="produtosAgregados"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.label) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'excluir'">
                            <b-button
                                v-if="permissao.delete && !produtoAgregadoIntegracao"
                                class="action-button"
                                :type="
                                    props.row['replicapda'] == 3 ? 'is-danger' : 'is-success'
                                "
                                :icon-right="props.row['replicapda'] == 3 ? 'delete' : 'check'"
                                @click="promptChangeSituacao(props.row)"
                                v-tippy 
                                :title="$t(props.row['replicapda'] == 3 ? 'desativar' : 'reativar')"
                            />
                        </div>
                        <div v-else-if="f.key == 'replicapda'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                :type="props.row['replicapda'] == 3 ? 'is-success' : 'is-danger'"
                                size="is-medium"
                            >
                                {{ $t(props.row['replicapda'] == 3 ? 'ativo' : 'inativo') }}
                            </b-tag>
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>

            <!-- MODAL DE ASSOCIACAO -->
            <b-modal :active.sync="showModalAgregados" @close="fecharModal">
                <div class="bg">
                    <AgregadoModal @fecharModal="fecharModal" />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
import VenProdutoService from '@/services/vendas/produto/VenProdutoService';
import Message from '@/models/Message';
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import AgregadoModal from '@/components/vendas/produto/modal/politica-comercial/AgregadoModal.vue';

export default {
    components: {
        ContainerLoader,
        AgregadoModal,
    },
    data() {
        return {
            service: null,
            empresaService: null,
            validation: null,
            idpedido: 0,
            produtosAgregados: [] /* Produtos agregados associados */,
            hasListeners: false,
            isUpdate: false,
            fields: [
                { key: 'descricao', label: 'produto', sortable: true },
                { key: 'grupoproduto', label: 'grupoproduto', sortable: true },
                { key: 'subgrupoproduto', label: 'subgrupoproduto', sortable: true },
                { key: 'replicapda', label: 'replicapda', sortable: true },
                { key: 'excluir', width: 20, sortable: false, sortFn: null },
            ],
            produtoAgregadoIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'PRODUTOAGREGADO'
            ),
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'nome',
            order: 'asc',
            delete: null,
            isSaving: false,
            showModalAgregados: false,
            showModalCadastroProduto: false,
            situacaoSelected: { id: 4, label: 'todos' },
            situacaoSelect: [
                { id: 4, label: 'todos' },
                { id: 3, label: 'ativos' },
                { id: 2, label: 'inativos' },
            ],
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess(
            'vendas',
            'produtos',
            'ven-produto-politica-comercial-agregado'
        );

        !this.permissao.read &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'agregado' },
            });

        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.service = new VenProdutoService(this.$http, this.$router);

        this.idproduto = this.$route.params.id;
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);

        this.loadTabAgregados();
    },
    methods: {
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.loadTabAgregados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.loadTabAgregados();
        },
        loadTabAgregados(currentPage = 1) {
            this.isLoading = true;

            this.service
                .loadAgregados(
                    this.idproduto,
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacaoSelected.id,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((r) => {
                    this.produtosAgregados = r;

                    this.isEmpty = this.produtosAgregados.length <= 0;
                })
                .catch((e) => {
                    console.error('Erro ao carregar agregadoes e agregados.', e);

                    this.msgs.push(new Message('error', 'msg-erro-agregadoes-agregados', true));
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    ididprodutoagregado: m.ididprodutoagregado,
                    codigo: m.idprodutoerp,
                    descricao: m.descricao,
                    idprodutoprincipal: m.idprodutoprincipal,
                    idproduto: m.idproduto,
                    datahorainc: m.datahorainc,
                    grupoproduto: m.descricaoGrupo,
                    subgrupoproduto: m.descricaoSubgrupo,
                    replicapda: m.replicapda,
                };
            });
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.replicapda == 3
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row['descricao'] }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        updateSituacaoRegistro() {
            let tempFailure = this.$t(
                    this.delete.replicapda == 3
                        ? 'msg-erro-ao-reativar-n'
                        : 'msg-erro-ao-desativar-n', 
                    { n: this.$t('agregado') }
                );
            let tempProdutoAgregado = {
                ididprodutoagregado: this.delete.ididprodutoagregado,
                replicapda: this.delete.replicapda == 3 ? 2 : 3,
            };
            this.isLoading = true;
            this.service
                .updateSituacaoAgregado(tempProdutoAgregado)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess = this.$t(
                                r.content.replicapda == 3
                                    ? 'msg-sucesso-ao-reativar-n'
                                    : 'msg-sucesso-ao-desativar-n', 
                                { n: this.$t('agregado') }
                            );
                        this.$root.showMessage('success', tempSuccess, true, false);
                        this.loadTabAgregados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure, true, false);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        removePrompt() {
            this.delete = null;
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.loadTabAgregados(value.currentPage);
        },
        fecharModal() {
            this.showModalAgregados = false;
            this.isUpdate = false;
            this.showModalCadastroProduto = false;
            this.loadTabAgregados();
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.loadTabAgregados();
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-produto-agregado {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>
